import { render, staticRenderFns } from "./reservation-info.vue?vue&type=template&id=0c384520&scoped=true"
import script from "./reservation-info.vue?vue&type=script&lang=js"
export * from "./reservation-info.vue?vue&type=script&lang=js"
import style0 from "./reservation-info.vue?vue&type=style&index=0&id=0c384520&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c384520",
  null
  
)

export default component.exports